import React from 'react';
import { JsonLd } from 'react-schemaorg';

/** See https://schema.org/ItemList */
import { jsx as _jsx } from "react/jsx-runtime";
export const FeaturedPagesStructuredData = _ref => {
  let {
    pages,
    baseUrl
  } = _ref;
  if (!pages || pages.length === 0) {
    return null;
  }

  // Determine page type based on URL
  const getItemType = url => {
    if (url.includes('/collections/')) {
      return 'CollectionPage';
    }
    if (url.includes('/categories/')) {
      return 'CategoryPage';
    }
    if (url.includes('/search')) {
      return 'SearchResultsPage';
    }
    // Default to CollectionPage for backward compatibility
    return 'CollectionPage';
  };
  const getFullUrl = url => {
    if (url.startsWith('http')) {
      return url;
    }
    return "".concat(baseUrl).concat(url);
  };
  const itemList = {
    '@context': 'https://schema.org/',
    '@type': 'ItemList',
    name: 'Featured Collections, Categories, and Search Pages',
    description: 'Browse featured collections, categories, and search result pages of Marketplace apps',
    itemListElement: pages.map((page, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': getItemType(page.url),
        name: page.title,
        description: page.description,
        url: getFullUrl(page.url)
      }
    }))
  };
  return /*#__PURE__*/_jsx(JsonLd, {
    item: itemList
  });
};